import { SkeletonCircle, SkeletonText } from '@cardboard-ui/react';
import React from 'react';
import { Handle } from '../Handle';

export const Skeleton = () => (
  <Handle
    name={<SkeletonText noOfLines={1} />}
    description={<SkeletonText w="20%" noOfLines={1} />}
    icon={<SkeletonCircle size="6" />}
  />
);
